import computed from './attrs/computed'
import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import watch from './attrs/watch'

import PagarmeRecipient from '../../../components/PagarmeRecipient/Index'
import PagarmeKycLinkGenerator from '../../../components/PagarmeKycLinkGenerator/Index'

import {VueEditor} from 'vue2-editor'

import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'

export default {
    name: 'AgencyForm',
    computed,
    data,
    methods,
    mounted,
    watch,
    components: {
        PagarmeKycLinkGenerator,
        VueEditor,
        Cropper,
        PagarmeRecipient,
    }
}
